export const INCOME_VERIFICATION_STATUS_CREATED = 'created';
export const INCOME_VERIFICATION_STATUS_STARTED = 'started';
export const INCOME_VERIFICATION_STATUS_PENDING = 'pending';
export const INCOME_VERIFICATION_STATUS_FAILED = 'failed';
export const INCOME_VERIFICATION_STATUS_COMPLETED = 'completed';

export const INCOME_VERIFICATION_STATUS_LIST = [
  INCOME_VERIFICATION_STATUS_CREATED,
  INCOME_VERIFICATION_STATUS_STARTED,
  INCOME_VERIFICATION_STATUS_PENDING,
  INCOME_VERIFICATION_STATUS_FAILED,
  INCOME_VERIFICATION_STATUS_COMPLETED,
];

export const INCOME_VERIFICATION_STATUS_LIST_NOT_COMPLETED = [
  INCOME_VERIFICATION_STATUS_CREATED,
  INCOME_VERIFICATION_STATUS_STARTED,
  INCOME_VERIFICATION_STATUS_PENDING,
];

export const INCOME_VERIFICATION_PROVIDER_CLOSING_DOCS = 'closingDocs';
export const INCOME_VERIFICATION_PROVIDER_VERIFAST = 'verifast';
export const INCOME_VERIFICATION_PROVIDER_FINICITY = 'finicity';
export const INCOME_VERIFICATION_PROVIDER_PINWHEEL = 'pinwheel';

export const INCOME_VERIFICATION_PROVIDER_NAME_MAPPING = {
  [INCOME_VERIFICATION_PROVIDER_CLOSING_DOCS]: 'The Closing Docs',
  [INCOME_VERIFICATION_PROVIDER_VERIFAST]: 'VeriFast',
  [INCOME_VERIFICATION_PROVIDER_FINICITY]: 'Finicity',
  [INCOME_VERIFICATION_PROVIDER_PINWHEEL]: 'Pinwheel',
};

export const INCOME_VERIFICATION_DEFAULT_EXPIRED_REPORT_URL =
  'https://s3.amazonaws.com/sr-media-prod/voi-expired-report.pdf'; // eslint-disable-line max-len
export const INCOME_VERIFICATION_DEFAULT_PROVIDER = INCOME_VERIFICATION_PROVIDER_PINWHEEL;

export const INCOME_VERIFICATION_DOCS_EXPIRATION_IN_DAYS = 60;
